export { TherapistCard } from "./TherapistCard"
